import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchLastWatched } from './queryFunctions';
import { createLastWatchedQueryOptions } from './queryOptions';

export function fetchLastWatchedQuery() {
  return queryClient.fetchQuery(createLastWatchedQueryOptions());
}

export function prefetchLastWatchedQuery() {
  return queryClient.prefetchQuery(createLastWatchedQueryOptions());
}

export function getLastWatchedQueryData() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchLastWatched>>>(queryKeys.lastWatched);
}
